const MAP_IMAGE = "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/ab7bbe9b-cd36-4777-b8f7-02ce6e65ea8b.png";

// Positions adjusted for new vertical map (1830x3000)
// Each position corresponds to the numbered circles on the map
const STICKERS = [
  { id: 1, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/c781c026-b7bb-43ec-a91f-65d5c1439e62.png", x: 50.6, y: 88.7, size: 12 },
  { id: 2, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/387bffaf-f997-4520-b591-f2363499134d.png", x: 23.7, y: 77.9, size: 10 },
  { id: 3, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/3d05177d-c97c-4808-8593-217ddd223fb0.png", x: 52.1, y: 68.7, size: 12 },
  { id: 4, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/1560a678-a00a-4146-9c93-56b6c65cded3.png", x: 71.1, y: 58, size: 10 },
  { id: 5, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/40f527ff-70b4-47b2-81b0-b9b1ab0e6db2.png", x: 34.5, y: 56.8, size: 12 },
  { id: 6, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/413b85ff-b7fa-41c0-bd70-5cd8f733e2a4.png", x: 23.8, y: 46.4, size: 14 },
  { id: 7, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/3e41e004-5e8b-4dde-818c-20186459c076.png", x: 49.6, y: 43.6, size: 14 },
  { id: 8, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/60752f5a-c608-4e0c-a508-b544e41627f0.png", x: 74.9, y: 40.6, size: 10 },
  { id: 9, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/0f9848f5-0899-4f73-9490-7d66360fa2ae.png", x: 57.9, y: 33.7, size: 11 },
  { id: 10, url: "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/dbfb08f7-0a8c-4598-bfbd-9d2f07943acc.png", x: 49.6, y: 23.7, size: 10 },
];

const LoyaltyPath = ({ currentStep = 0 }) => {
  return (
    <div 
      className="relative w-full rounded-3xl overflow-hidden"
      data-testid="loyalty-path"
    >
      {/* Map Background */}
      <img 
        src={MAP_IMAGE}
        alt="Mapa de Lealtad"
        className="w-full h-auto"
      />
      
      {/* Stickers Overlay */}
      {STICKERS.map((sticker) => {
        const isCompleted = sticker.id <= currentStep;
        
        return isCompleted ? (
          <img
            key={sticker.id}
            src={sticker.url}
            alt={`Sticker ${sticker.id}`}
            className="absolute sticker-stamp"
            style={{
              left: `${sticker.x}%`,
              top: `${sticker.y}%`,
              width: `${sticker.size || 12}%`,
              height: 'auto',
              transform: 'translate(-50%, -50%)',
            }}
            data-testid={`sticker-${sticker.id}`}
          />
        ) : null;
      })}
    </div>
  );
};

export default LoyaltyPath;
